<div [class]="styleClass" [ngClass]="{
  'app-input-wrapper form-group flex-column': true,
  'input-primary': theme === 'primary',
  'input-secondary': theme === 'secondary',
  'input-light': theme === 'light',
  'input-border': theme === 'border',
  'active': isActive,
  'invalid': isInvalid,
  'hover-effect': hasHoverEffect,
  'active-bg': hasBgOnActive,
  'float-label': isActive || value?.length > 0,
  'no-border-bottom': !hasBorderBottomOnActive,
  'disabled': disabled,
  'input-icon-left': leftIcon,
  'input-icon-right': rightIcon,
  'font-family': fontFamily,
  'input-action-wrapper': hasActions || hasShowPasswordIcon
}" #textareaContainer>
  <div class="flex-start-start width-100p">
    <i [class]="leftIcon" [ngClass]="{'left-icon font-gray': true}" *ngIf="leftIcon"></i>
    <textarea autocomplete="new-name" [disabled]="disabled" [id]="'V'+textAreaId" [class]="styleClassInput"
      [readonly]="readOnly" [rows]="rows"
      [ngClass]="{'disabled': disabled, 'app-input': true, 'app-float-input': floatingLabel}"
      [ngStyle]="{fontSize: fontSize + 'px',cursor: disabled || prohibited? 'not-allowed': 'text'}"
      [maxlength]="maxLength" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" (click)="onClick()"
      (focus)="onFocus()" (blur)="onBlur()" (ngModelChange)="onModalChange($event)" (keydown.enter)="onEnter()"
      (keydown.tab)="onTabPress()" #textareaControl></textarea>
    <i [class]="rightIcon" [ngClass]="{'right-icon font-gray': true}" *ngIf="rightIcon" (click)="handleRightIconClick()"></i>
    <i [class]="cancelIcon" [ngClass]="{'input-action cancel-icon font-gray pointer': true}" *ngIf="hasActions"
      (click)="onCancel()"></i>
    <i [class]="saveIcon" [ngClass]="{'input-action save-icon font-gray pointer': true}" *ngIf="hasActions"
      (click)="onSave()"></i>
    <i [class]="(isPasswordHidden)? 'fa-eye': 'fa-eye-slash'"
      [ngClass]="{'fas input-action eye-icon font-gray pointer': true}" *ngIf="hasShowPasswordIcon"
      (click)="toggleHidePassword()"></i>
  </div>
  <label [hidden]="!floatingLabel" [class]="styleClassLabel"
    [ngClass]="{'disabled': disabled, 'app-input-label': true, 'app-label-float': floatingLabel}" (click)="onFocus()">
    {{label || placeholder}}
  </label>
  <div [id]="validationId" class="app-input-error" [ngClass]="{'app-input-warning':warningMessage, 'd-flex':errorIcon}" [class]="errorClass">
    <i *ngIf="isInvalid" class="{{errorIcon}} align-self-center pr-1"></i>{{errorMessage}}
  </div>
</div>
